// components/gifts/GiftHeroBit.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const GiftHeroBit = ({ title, subtitle, tagline }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, amount: 0.3 });

    return (
        <section ref={ref} className="relative min-h-[85vh] flex items-center bg-ivory overflow-hidden">
            <motion.div
                initial={{ scale: 1.1 }}
                animate={isInView ? { scale: 1 } : {}}
                transition={{ duration: 1.8, ease: "easeOut" }}
                className="absolute inset-0"
                style={{
                    backgroundImage: 'linear-gradient(135deg, rgba(245,245,240,0.95) 0%, rgba(255,255,255,0.8) 100%), url(/images/gift-hero-bg.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            />

            <div className="container mx-auto px-6 lg:px-12 relative z-10">
                <div className="max-w-2xl">
                    <motion.div
                        initial={{ y: 60, opacity: 0 }}
                        animate={isInView ? { y: 0, opacity: 1 } : {}}
                        transition={{ duration: 1.2, delay: 0.3 }}
                    >
                        <h1 className="font-playfair text-6xl md:text-8xl text-charcoal mb-6 leading-none">
                            {title}
                        </h1>
                        {subtitle && (
                            <p className="font-poppins text-2xl text-charcoal/70 mb-8">
                                {subtitle}
                            </p>
                        )}
                    </motion.div>

                    {tagline && (
                        <motion.div
                            initial={{ opacity: 0, width: 0 }}
                            animate={isInView ? { opacity: 1, width: '100%' } : {}}
                            transition={{ duration: 1.5, delay: 0.8 }}
                            className="overflow-hidden"
                        >
                            <p className="font-cormorant text-xl text-sage-green pt-8 border-t border-charcoal/20">
                                {tagline}
                            </p>
                        </motion.div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default GiftHeroBit;